// @flow

import React from 'react'
import styled from 'styled-components'
import theme from 'styled-theming'
import Link from 'gatsby-link'

import { myTheme, themedTextColor, themedTextColorRgb } from '../../styles'

const { color, fontWeight } = myTheme

const NavigationLinkActive = '_nav-item-is-active'
const linkColor = theme('mode', {
  dark: color.darkSilver,
  light: color.lightBlueGray,
})

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${linkColor};
  transition: all 150ms ease-in-out;
  font-weight: ${fontWeight.five};
  border-bottom: 2px solid transparent;

  &:hover {
    color: ${themedTextColor};
  }

  &.${NavigationLinkActive} {
    color: ${themedTextColor};
    border-bottom: 2px solid rgba(${themedTextColorRgb}, 0.2);
  }
`

type Props = {
  to: string,
  children: Node,
  activeClassName?: string,
}

const NavigationLink = ({ children, to, activeClassName }: Props) => (
  <StyledLink
    to={to}
    activeClassName={activeClassName}
  >
    {children}
  </StyledLink>
)
NavigationLink.defaultProps = {
  activeClassName: NavigationLinkActive,
}

export { NavigationLink, NavigationLinkActive }



// WEBPACK FOOTER //
// ./src/components/navigation/navigation-link.js